/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Signinmore2Inputs */

const zh_account_signinmore2 = /** @type {(inputs: Account_Signinmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录更多账号`)
};

const en_account_signinmore2 = /** @type {(inputs: Account_Signinmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in with another account`)
};

const es_account_signinmore2 = /** @type {(inputs: Account_Signinmore2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión con otra cuenta`)
};

/**
* | output |
* | --- |
* | "Sign in with another account" |
*
* @param {Account_Signinmore2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const account_signinmore2 = /** @type {((inputs?: Account_Signinmore2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Signinmore2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_account_signinmore2(inputs)
	if (locale === "en") return en_account_signinmore2(inputs)
	return es_account_signinmore2(inputs)
});
export { account_signinmore2 as "account_signInMore" }